import React from 'react';
import UserEmulationModal from './UserEmulationModal';
export const UserEmulation = ({ open, setOpen }) => {
    return React.createElement(UserEmulationModal, { open: open, setOpen: setOpen });
};
export default UserEmulation;
